"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SiteHeader = void 0;
const react_1 = __importDefault(require("react"));
const SiteTitle_1 = require("../../atoms/SiteTitle/SiteTitle");
const ClueyLogoBase_1 = require("../../atoms/ClueyLogoBase/ClueyLogoBase");
const SiteHeader = ({ label, children, logoSrc, logoSrcDark, to }) => {
    const logo = to ? (react_1.default.createElement("a", { href: to },
        react_1.default.createElement(ClueyLogoBase_1.ClueyLogoBase, { src: logoSrc, className: "dark:hidden" }),
        logoSrcDark && react_1.default.createElement(ClueyLogoBase_1.ClueyLogoBase, { src: logoSrcDark, className: "dark:inline" }))) : (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(ClueyLogoBase_1.ClueyLogoBase, { src: logoSrc, className: "dark:hidden" }),
        logoSrcDark && react_1.default.createElement(ClueyLogoBase_1.ClueyLogoBase, { src: logoSrcDark, className: "dark:inline" })));
    return (react_1.default.createElement("div", { className: "relative flex h-14 w-full border-b-4 border-blood-orange-4 bg-white px-4 dark:bg-grey-6 lg:h-20 lg:px-0" },
        react_1.default.createElement("div", { className: "container mx-auto flex items-center justify-between" },
            react_1.default.createElement("header", { className: "flex items-center" },
                logo,
                react_1.default.createElement(SiteTitle_1.SiteTitle, { title: label })),
            children)));
};
exports.SiteHeader = SiteHeader;
